/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Extension_Popup_Currentpage_Trackonpricedrop3Inputs */

const he_extension_popup_currentpage_trackonpricedrop3 = /** @type {(inputs: Extension_Popup_Currentpage_Trackonpricedrop3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`התחל מעקב ב-pricedrop`)
};

const en_extension_popup_currentpage_trackonpricedrop3 = /** @type {(inputs: Extension_Popup_Currentpage_Trackonpricedrop3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Track on pricedrop`)
};

/**
* | output |
* | --- |
* | "Track on pricedrop" |
*
* @param {Extension_Popup_Currentpage_Trackonpricedrop3Inputs} inputs
* @param {{ locale?: "he" | "en" }} options
* @returns {LocalizedString}
*/
const extension_popup_currentpage_trackonpricedrop3 = /** @type {((inputs?: Extension_Popup_Currentpage_Trackonpricedrop3Inputs, options?: { locale?: "he" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Extension_Popup_Currentpage_Trackonpricedrop3Inputs, { locale?: "he" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "he") return he_extension_popup_currentpage_trackonpricedrop3(inputs)
	return en_extension_popup_currentpage_trackonpricedrop3(inputs)
});
export { extension_popup_currentpage_trackonpricedrop3 as "extension_popup_currentPage_trackOnPricedrop" }